class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.addToCartButton = this.querySelector('.add-to-cart');
        this.current_variant_id = this.getAttribute('variant-id');
        this.productHandle = this.getAttribute('product-handle');

        this.variants = JSON.parse(this.querySelector('#product-variants-json').innerText);
        this.currentVariant = this.variants.find(variant => variant.id == this.current_variant_id);
    }

    // ✅ Currency Formatting Function (Custom Symbols)
    formatMoney(cents) {
        const activeCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}';
        const v = Number(cents) / 100;
        if (isNaN(v)) return '0.00';

        switch (activeCurrency) {
            case "INR":
                return 'Rs ' + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "USD":
                return '$' + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "DKK":
                return v.toLocaleString("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kr";
            case "AED":
                return 'Dhs ' + v.toLocaleString("en-AE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "EUR":
                return '€' + v.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "GBP":
                return '£' + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "CAD":
                return 'CA$' + v.toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            case "AUD":
                return 'A$' + v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            default:
                try {
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: activeCurrency
                    }).format(v);
                } catch (e) {
                    return v.toFixed(2) + ' ' + activeCurrency;
                }
        }
    }

    updatePrice(variantId) {
        const priceEl = document.getElementById('current-variant-price');
        const compareEl = document.getElementById('current-variant-compare-price');
        const badgeEl = document.querySelector('.main-product-badge');

        if (!priceEl) return;

        const variant = this.variants.find(v => v.id == variantId);
        if (!variant) return;

        const priceCents = variant.price_cents || 0;
        const compareCents = variant.compare_at_price_cents || 0;

        // ✅ Update main price
        priceEl.innerText = this.formatMoney(priceCents);

        // ✅ Update compare price with strikethrough
        if (compareEl) {
            if (compareCents > priceCents) {
                compareEl.innerHTML = `<s>${this.formatMoney(compareCents)}</s>`;
                compareEl.style.display = 'inline';
            } else {
                compareEl.style.display = 'none';
            }
        }

        // ✅ Update discount badge
        if (badgeEl) {
            if (compareCents > priceCents) {
                const discount = Math.round(((compareCents - priceCents) / compareCents) * 100);
                badgeEl.innerText = `Spar ${discount}%`;
                badgeEl.style.display = 'inline';
            } else {
                badgeEl.style.display = 'none';
            }
        }
    }

    connectedCallback() {
        this.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.addEventListener('change', this.updateVariant.bind(this));

        if (this.querySelector('#main-variant-select')) this.querySelector('#main-variant-select').style.display = 'none';
        if (this.querySelector('.product-variant-options')) this.querySelector('.product-variant-options').style.display = 'block';

        window.addEventListener('DOMContentLoaded', () => this.updatePrice(this.currentVariant.id));
        window.addEventListener('load', () => this.updatePrice(this.currentVariant.id));

        document.addEventListener('shopify:section:load', () => this.updatePrice(this.currentVariant.id));
        document.addEventListener('shopify:section:select', () => this.updatePrice(this.currentVariant.id));
        document.addEventListener('shopify:block:select', () => this.updatePrice(this.currentVariant.id));
    }

    disconnectedCallback() {
        this.removeEventListener('submit', this.handleFormSubmit.bind(this));
        this.removeEventListener('change', this.updateVariant.bind(this));
    }

    updateVariant() {
        let selectedOptions = [];
        this.querySelectorAll('[name^="option-"]:checked').forEach(input => {
            selectedOptions.push(input.value);
            const wrapper = input.closest('.variant-option');
            if (wrapper) wrapper.querySelector('.selected-value').innerText = input.value;
        });

        this.currentVariant = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selectedOptions));
        if (!this.currentVariant) return;

        this.querySelector('.selected-variant-id').value = this.currentVariant.id;
        window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);

        // if (this.currentVariant.featured_image) {
        //     const imageId = this.currentVariant.featured_image.id;
        //     const index = Array.from(document.querySelectorAll('.main-slider img'))
        //         .findIndex(img => img.dataset.imageId == imageId);
        //     if (index >= 0 && window.mainSlider) window.mainSlider.slideTo(index);
        // }





/* ------------------------------------
   VARIANT → MEDIA CHANGE (ALL LAYOUTS)
-------------------------------------*/

const variantMedia = this.currentVariant?.featured_media;
if (variantMedia) {
    const mediaId = variantMedia.id;

    // Detect layout
    const layout = document.querySelector('.product-page-container')?.dataset.layout;

    // Find ALL media (image/video/model)
    const allMedia = Array.from(
        document.querySelectorAll('.product-gallery [data-image-id], .product-gallery [data-media-id]')
    );

    // Create normalised dataset key
    const targetIndex = allMedia.findIndex(item => {
        return (
            item.dataset.imageId == mediaId ||
            item.dataset.mediaId == mediaId
        );
    });

    /* ------------------------------------
       CASE 1: SLIDER MODE (thumbnail_carousel + mobile)
    -------------------------------------*/
    if (layout === "thumbnail_carousel" || window.innerWidth < 750) {
        if (window.mainSlider && targetIndex >= 0) {
            window.mainSlider.slideTo(targetIndex);
        }
    }

    /* ------------------------------------
       CASE 2: STACKED / COLUMNS MODE
       → Move active media to FIRST
    -------------------------------------*/
    if (layout === "stacked" || layout === "columns") {
        const gallery = document.querySelector('.thumbnails');
        if (gallery && targetIndex >= 0) {
            const targetNode = allMedia[targetIndex].closest('.thumbnail');
            if (targetNode) {
                gallery.prepend(targetNode);
            }
        }
    }

    /* ------------------------------------
       UPDATE ACTIVE CLASS (thumbnails)
    -------------------------------------*/
    document.querySelectorAll('.thumbnail-image').forEach(img =>
        img.classList.remove('active')
    );

    const activeThumb =
        document.querySelector(`.thumbnail-image[data-image-id="${mediaId}"]`) ||
        document.querySelector(`.thumbnail-image[data-media-id="${mediaId}"]`);

    if (activeThumb) activeThumb.classList.add('active');
}






        this.updatePrice(this.currentVariant.id);

        const inputButton = this.querySelector('button[type="submit"]');
        if (!this.currentVariant.available) {
            inputButton.setAttribute('disabled', '');
            inputButton.innerText = 'SOLD OUT';
        } else {
            inputButton.removeAttribute('disabled');
            inputButton.innerText = 'Add to cart';
        }
    }

    handleFormSubmit(evt) {
        evt.preventDefault();
        const formData = new FormData(this.form);
        document.querySelector('side-cart').classList.remove('loaded');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(json => {
            if (json.status != 'bad_request') {
                document.querySelector('side-cart').addLineItem(json);
            } else {
                alert('Error: ' + json.message);
            }
        })
        .catch(err => {
            alert('Error: ' + err);
            console.error('Error:', err);
        });
    }
}

customElements.define('product-form', ProductForm);